'use client';

import { FormControlLabel, Checkbox } from '@mui/material';
import { useState, useEffect } from 'react';

interface CookiePreferenceProps {
  label: string;
  type: 'performance' | 'functional' | 'advertising';
  initialValue?: boolean;
  onChange?: (type: string, value: boolean) => void;
}

export default function CookiePreference({ 
  label, 
  type, 
  initialValue = true,
  onChange 
}: CookiePreferenceProps) {
  const [isEnabled, setIsEnabled] = useState(initialValue);

  useEffect(() => {
    setIsEnabled(initialValue);
  }, [initialValue]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;
    setIsEnabled(newValue);
    onChange?.(type, newValue);
  };

  return (
    <FormControlLabel
      control={
        <Checkbox 
          checked={isEnabled}
          onChange={handleChange}
        />
      }
      label={label}
      sx={{ color: 'text.primary' }}
    />
  );
}
